import { Box, Typography } from '@mui/material';

export const NotFound = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <Typography variant="h1">Page Not Found</Typography>
    </Box>
  );
};
